import { Box, Typography } from "@mui/material";

const CreditSimulationHeader = () => {
  return (
    <Box>
      <Typography
        sx={{
          fontWeight: 400,
          fontSize: 24,
        }}
        color="inherit"
        noWrap
      >
        Antecipação de recebíveis a fornecedores
      </Typography>
      <Typography
        sx={{
          fontWeight: 400,
          fontSize: 16,
          color: "#8087A6",
        }}
        color="inherit"
        noWrap
      >
        Condições da simulação da antecipação
      </Typography>
    </Box>
  );
};

export default CreditSimulationHeader;
